import { checkBrowser } from "./Utils"
import CONSTANTS from "./Constants";

export default class MouseGyroListener{

    constructor (options) {
        this.init(options);
    }

    init(scene){
        this.lastGyroUpdate = performance.now();
        this.lastGyroX = 0;
        this.lastGyroY = 0;
        this.scene = $(scene);

        this.updateSceneSize(this.scene);

        this.scene[0].onmousemove = this._onMouseMove.bind(this);

        if (window.DeviceMotionEvent !== undefined) {

            this.implementationFix = 1;
            if(checkBrowser() === CONSTANTS.VENDORS.SAFARI){
                this.implementationFix = -1;
            }
            window.ondevicemotion = this._onDeviceMotion.bind(this);
        }
    }

    _notify(data){
        this.scene.trigger("mousegyro.maglr", data);
    }

    /**
     *
     *
     * from: https://stackoverflow.com/questions/7790725/javascript-track-mouse-position
     * @param event
     * @private
     */
    _onMouseMove(event) {
        event = event || window.event;

        let x_mid = (this.scenewidth/2),
            y_mid = (this.sceneheight/2),
            data = {
                x:  event.clientX - x_mid,
                xp: Math.round((event.clientX - x_mid) / (x_mid/100)),
                y:  event.clientY - y_mid,
                yp: Math.round((event.clientY - y_mid) / (y_mid/100))
            }
        ;

        this._notify(data);
    }

    /**
     *
     *
     * from: http://www.albertosarullo.com/blog/javascript-accelerometer-demo-source
     * @param e
     * @private
     */
    _onDeviceMotion(e) {
        if (e - this.lastGyroUpdate < 500) {
            requestAnimationFrame( (e) => this._onDeviceMotion(e))
        } else {
            this.lastGyroUpdate = e;

            let x, y, screenOrientation = screen.orientation || window.orientation; // window for ios safari, screen for all other

            //Chrome on Android returns an object
            if (screenOrientation.type) {
                screenOrientation = screenOrientation.type;
            }

            if (screenOrientation || window.orientation) {
                if (screenOrientation === 'portrait-primary' || screenOrientation === 0) {
                    x = e.accelerationIncludingGravity.x * this.implementationFix;
                    y = e.accelerationIncludingGravity.y * this.implementationFix;
                } else if (screenOrientation === 'landscape-primary' || screenOrientation === 90) {
                    //in landscape switch the x and y
                    x = e.accelerationIncludingGravity.y * this.implementationFix;
                    y = e.accelerationIncludingGravity.x * this.implementationFix;
                } else if (screenOrientation === 'landscape-secondary' || screenOrientation === -90) {
                    //in landscape switch the x and y
                    x = e.accelerationIncludingGravity.y * this.implementationFix * -1;
                    y = e.accelerationIncludingGravity.x * this.implementationFix * -1;
                } else if (screenOrientation === 'portrait-secondary' || screenOrientation === 180) {
                    x = e.accelerationIncludingGravity.x * this.implementationFix * -1;
                    y = e.accelerationIncludingGravity.y * this.implementationFix * -1;
                }
            } else { // portrait-primary

            }

            if (Math.abs(x - this.lastGyroX) > 0.5 || Math.abs(y - this.lastGyroY) > 0.5) {
                this.lastGyroX = x;
                this.lastGyroY = y;

                let x_mid = (this.scenewidth / 2),
                    y_mid = (this.sceneheight / 2),
                    data = {
                        x: Math.round((x / 10) * x_mid),
                        xp: Math.round(x * 10),
                        y: Math.round((y / 10) * y_mid),
                        yp: Math.round(y * 10)
                    }
                ;

                // Use event.pageX / event.pageY here
                this._notify(data);
            }

        }

    }

    updateSceneSize(scene){
        this.scenewidth = scene.width();
        this.sceneheight = scene.height();
    }

    destroy(){
        this.scene[0].onmousemove  = null;
        window.ondevicemotion = null;
    }
}
